<template>
  <tr>
    <td>
      <router-link
        :to="{
          name: 'single_user',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.name }}
      </router-link>
    </td>
    <td class="text-xs-left">
      {{ props.item.email }}
    </td>
    <td class="text-xs-left">
      {{ props.item.type }}
    </td>
    <td class="text-xs-left">
      {{ props.item.created_at | timezone }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'UserDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
